import { Sparkles } from "lucide-react";

/**
 * Tiny inline badge showing the credit cost of an AI action.
 *
 * Usage:
 *   <CreditCostTag cost={5} />           → "~5 credits"
 *   <CreditCostTag cost={15} />          → "~15 credits"
 */
export default function CreditCostTag({ cost = 1 }) {
  if (!cost) return null;

  return (
    <span
      className="inline-flex items-center gap-1 text-xs text-muted-foreground"
      data-testid="credit-cost-tag"
    >
      <Sparkles className="w-3 h-3" />
      ~{cost} credit{cost !== 1 ? "s" : ""}
    </span>
  );
}
